<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/lp/business_college_headder.jpg" class="only_pc" />
        <img src="@/assets/img/lp/business_college_headder.jpg" class="only_sp" />
      </div>
    </div>
  </section>

  <section class="msc_seminar mt-5">
    <p>
      11月より、ビジネス会員の皆さまを対象に、下記の通りセミナーを開催いたします。<br>
      ぜひご参加いただき、マナビスの魅力を大切な方々にお伝えください。
    </p>
    <h3 class="ttl-cmn-03 mt-3 pt-5" style="font-size: 20px;">≪ウェルカムセミナー≫</h3>
    <p>
      マナビスの「会社・商品・ボーナスプラン」についてご紹介。<br>
      マナビスの魅力、ビジネスチャンスを余すことなくお伝えいたします。<br>
      ビジネス会員の皆さまが、新規の方にお話できるようになってほしい内容です。<br>
      ぜひ新規の方をお誘いし、上位会員のみなさまもご一緒にご参加ください。
    </p>
    <h3 class="ttl-cmn-03 mt-3 pt-5" style="font-size: 20px;">≪&nbsp;&nbsp;マナビスカレッジ&nbsp;&nbsp;≫</h3>
    <p class="pb-5">
      いわゆる「マナビスビジネスの伝え方」を新しくビジネス会員になった方が学ぶことができます。<br>
      新規会員の獲得、安定した商品流通につながる傘下の方々へのアプローチの仕方など、ビジネスの基本を知ることができる研修です。<br>
      ビジネス意識のある新規会員のみなさまと一緒に、事業として取り組まれている上位会員の皆さまも、ぜひご参加ください。
    </p>
    <P class="mt-5 mb-5 p-3 pb-5 d-flex justify-content-around">
      <span class="d-flex justify-content-center align-items-center" style="font-size: 2.5rem;">全会場とも</span>
      <span class="d-flex justify-content-center">
        【ウエルカムセミナー】13:00～14:00<br>
        【&nbsp;&nbsp;マナビスカレッジ&nbsp;&nbsp;】14:15～15:45
      </span>
    </p>
    <div class="only_pc">
      <table class="seminar_table w-100">
        <thead>
          <tr>
            <th style="width: 100px;">日付</th>
            <th colspan="2">開催地域</th>
            <th>会場</th>
            <th style="width: 150px;"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-center">11/16（水）</td>
            <td class="text-center"><a href="https://www.manavis-cosme.co.jp/salon/salon_access.html"><img src="@/assets/img/lp/ginzasalon.jpg" alt="東京" style="width: 150px;"></a></td>
            <td style="width: 70px;">東京</td>
            <td>
              銀座サロン<br>
              【zoomコード】833 7742 7198<br>
              東京都中央区銀座3-2-11<br>
              03-6263-2496
            </td>
            <td><img src="@/assets/img/lp/manseki.jpg" alt="満席御礼"></td>
          </tr>
          <tr>
            <td class="text-center">11/18（金）</td>
            <td class="text-center"><img src="@/assets/img/lp/shinoosaka_marubiru.jpg" alt="大阪" style="width: 150px;"></td>
            <td style="width: 70px;">大阪</td>
            <td>
              新大阪丸ビル会議室<br>
              新館6階会議室609号<br>
              大阪市東淀川区東中島1-18-27<br>
              06-6321-1516
            </td>
            <td><img src="@/assets/img/lp/manseki.jpg" alt="満席御礼"></td>
          </tr>
          <tr>
            <td class="text-center">11/19（土）</td>
            <td class="text-center"><img src="@/assets/img/lp/forestsendai.jpg" alt="仙台" style="width: 150px;"></td>
            <td style="width: 70px;">仙台</td>
            <td>
              フォレスト仙台<br>
              第7会議室<br>
              宮城県仙台市青葉区柏木1-2-45<br>
              022-271-9340
            </td>
            <td><img src="@/assets/img/lp/manseki.jpg" alt="満席御礼"></td>
          </tr>
          <tr>
            <td class="text-center">11/26（土）</td>
            <td class="text-center"><img src="@/assets/img/lp/hakata_businesscenter.jpg" alt="福岡" style="width: 150px;"></td>
            <td style="width: 70px;">福岡</td>
            <td>
              TKP博多駅筑紫口ビジネスセンター<br>
              701会議室<br>
              福岡県福岡市博多区博多駅中央街4-8<br>
              092-477-6055
            </td>
            <td><img src="@/assets/img/lp/manseki.jpg" alt="満席御礼"></td>
          </tr>
          <tr>
            <td class="text-center">11/27（日）</td>
            <td class="text-center"><img src="@/assets/img/lp/takatihohall.jpg" alt="宮崎" style="width: 150px;"></td>
            <td style="width: 70px;">宮崎</td>
            <td>
              高千穂ホール<br>
              1号室、2号室<br>
              宮崎市広島2丁目5-16-8F<br>
              0985-22-2228
            </td>
            <td><img src="@/assets/img/lp/manseki.jpg" alt="満席御礼"></td>
          </tr>
          <tr>
            <td class="text-center">12/14（水）</td>
            <td class="text-center"><a href="https://www.manavis-cosme.co.jp/salon/salon_access.html"><img src="@/assets/img/lp/ginzasalon.jpg" alt="東京" style="width: 150px;"></a></td>
            <td style="width: 70px;">東京</td>
            <td>
              銀座サロン<br>
              【zoomコード】833 7742 7198<br>
              東京都中央区銀座3-2-11<br>
              03-6263-2496
            </td>
            <td><img src="@/assets/img/lp/manseki.jpg" alt="満席御礼"></td>
          </tr>
          <tr>
            <td class="text-center">12/17（土）</td>
            <td class="text-center"><img src="@/assets/img/lp/shinoosaka_marubiru.jpg" alt="大阪" style="width: 150px;"></td>
            <td style="width: 70px;">大阪</td>
            <td>
              新大阪丸ビル会議室<br>
              新館5階会議室509号<br>
              大阪市東淀川区東中島1-18-27<br>
              06-6321-1516
            </td>
            <td><img src="@/assets/img/lp/manseki.jpg" alt="満席御礼"></td>
          </tr>
          <tr>
            <td class="text-center">12/18（日）</td>
            <td class="text-center"><img src="@/assets/img/lp/forestsendai.jpg" alt="仙台" style="width: 150px;"></td>
            <td style="width: 70px;">仙台</td>
            <td>
              フォレスト仙台<br>
              第5会議室、第6会議室<br>
              宮城県仙台市青葉区柏木1-2-45<br>
              022-271-9340
            </td>
            <td><img src="@/assets/img/lp/manseki.jpg" alt="満席御礼"></td>
          </tr>
          <tr>
            <td class="text-center">12/21（水）</td>
            <td class="text-center"><img src="@/assets/img/lp/hakata_businesscenter.jpg" alt="福岡" style="width: 150px;"></td>
            <td style="width: 70px;">福岡</td>
            <td>
              TKP博多駅筑紫口ビジネスセンター<br>
              701会議室<br>
              福岡県福岡市博多区博多駅中央街4-8<br>
              092-477-6055
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr>
          <tr>
            <td class="text-center">12/22（木）</td>
            <td class="text-center"><img src="@/assets/img/lp/takatihohall.jpg" alt="宮崎" style="width: 150px;"></td>
            <td style="width: 70px;">宮崎</td>
            <td>
              高千穂ホール<br>
              1号室、2号室<br>
              宮崎市広島2丁目5-16-8F<br>
              0985-22-2228
            </td>
            <td class="text-center"><img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 100px;"></td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="only_sp">
      <table class="seminar_table w-100">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">11/16（水）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.manavis-cosme.co.jp/salon/salon_access.html"><img src="@/assets/img/lp/ginzasalon.jpg" alt="東京" style="width: 150px;"></a><br>
              <span>東京</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/manseki.jpg" alt="満席御礼" style="width: 150px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              銀座サロン<br>
              【zoomコード】<br>
              833 7742 7198<br>
              東京都中央区銀座3-2-11<br>
              03-6263-2496
            </td>
          </tr>
        </tbody>
      </table>
    
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">11/18（金）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <img src="@/assets/img/lp/shinoosaka_marubiru.jpg" alt="大阪" style="width: 150px;"><br>
              <span>大阪</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/manseki.jpg" alt="満席御礼" style="width: 150px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              新大阪丸ビル会議室<br>
              新館6階会議室609号<br>
              大阪市東淀川区東中島1-18-27<br>
              06-6321-1516
            </td>
          </tr>
        </tbody>
      </table>
    
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">11/19（土）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <img src="@/assets/img/lp/forestsendai.jpg" alt="仙台" style="width: 150px;"><br>
              <span>仙台</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/manseki.jpg" alt="満席御礼" style="width: 150px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              フォレスト仙台<br>
              第7会議室<br>
              宮城県仙台市青葉区柏木1-2-45<br>
              022-271-9340
            </td>
          </tr>
        </tbody>
      </table>
    
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">11/26（土）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <img src="@/assets/img/lp/hakata_businesscenter.jpg" alt="福岡" style="width: 150px;"><br>
              <span>福岡</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/manseki.jpg" alt="満席御礼" style="width: 150px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              TKP博多駅筑紫口ビジネスセンター<br>
              701会議室<br>
              福岡県福岡市博多区博多駅中央街4-8<br>
              092-477-6055
            </td>
          </tr>
        </tbody>
      </table>
    
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">11/27（日）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <img src="@/assets/img/lp/takatihohall.jpg" alt="宮崎" style="width: 150px;"><br>
              <span>宮崎</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/manseki.jpg" alt="満席御礼" style="width: 150px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              高千穂ホール<br>
              1号室、2号室<br>
              宮崎市広島2丁目5-16-8F<br>
              0985-22-2228
            </td>
          </tr>
        </tbody>
      </table>
    
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">12/14（水）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <a href="https://www.manavis-cosme.co.jp/salon/salon_access.html"><img src="@/assets/img/lp/ginzasalon.jpg" alt="東京" style="width: 150px;"></a><br>
              <span>東京</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/manseki.jpg" alt="満席御礼" style="width: 150px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              銀座サロン<br>
              【zoomコード】<br>
              833 7742 7198<br>
              東京都中央区銀座3-2-11<br>
              03-6263-2496
            </td>
          </tr>
        </tbody>
      </table>
    
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">12/17（土）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <img src="@/assets/img/lp/shinoosaka_marubiru.jpg" alt="大阪" style="width: 150px;"><br>
              <span>大阪</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/manseki.jpg" alt="満席御礼" style="width: 150px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              新大阪丸ビル会議室<br>
              新館5階会議室509号<br>
              大阪市東淀川区東中島1-18-27<br>
              06-6321-1516
            </td>
          </tr>
        </tbody>
      </table>
    
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">12/18（日）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <img src="@/assets/img/lp/forestsendai.jpg" alt="仙台" style="width: 150px;"><br>
              <span>仙台</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/manseki.jpg" alt="満席御礼" style="width: 150px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              フォレスト仙台<br>
              第5会議室、第6会議室<br>
              宮城県仙台市青葉区柏木1-2-45<br>
              022-271-9340
            </td>
          </tr>
        </tbody>
      </table>
    
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">12/21（水）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <img src="@/assets/img/lp/hakata_businesscenter.jpg" alt="福岡" style="width: 150px;"><br>
              <span>福岡</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              TKP博多駅筑紫口ビジネスセンター<br>
              701会議室<br>
              福岡県福岡市博多区博多駅中央街4-8<br>
              092-477-6055
            </td>
          </tr>
        </tbody>
      </table>
    
      <table class="seminar_table w-100 mt-5">
        <tbody>
          <tr>
            <th>日付</th>
            <td class="text-center" colspan="2">12/22（木）</td>
          </tr>
          <tr>
            <th>開催地域</th>
            <td class="text-center">
              <img src="@/assets/img/lp/takatihohall.jpg" alt="宮崎" style="width: 150px;"><br>
              <span>宮崎</span>
            </td>
            <td class="text-center p-0" style="width: 100px;">
              <img src="@/assets/img/lp/uketsuke.png" alt="受付中" style="width: 75px;">
            </td>
          </tr>
          <tr>
            <th>会場</th>
            <td colspan="2">
              高千穂ホール<br>
              1号室、2号室<br>
              宮崎市広島2丁目5-16-8F<br>
              0985-22-2228
            </td>
          </tr>
        </tbody>
      </table>

    </div>
  </section>

  <section class="msc_seminar mt-5">
    <div>
      <h1 class="text-center pt-5">
        各会場とも定員数は50名様!<br>
        （銀座サロンは定員15名）
      </h1>
      <p class="text-center mt-5">
        ※事前申し込み先着制となります。<br>限定数に達した時点で受付終了とさせていただきますので、予めご了承ください。
      </p>
      <p class="text-center mt-3">
        ★各会場の案内板等でお部屋をご確認のうえ、お越しください。
      </p>
    </div>

    <h3 class="ttl-cmn-03 mt-5 pt-5" style="font-size: 20px;">【申し込み方法】</h3>
    <p class="txt-cmn-01">ウェルカムセミナーは先着順受付になります。<br>マナビスカレッジへのご参加をご希望の方は、次の&#9312;〜&#9315;を弊社宛（<a href="mailto:mc-info@manavis-cosme.co.jp">mc-info@manavis-cosme.co.jp</a>）にメールにてご提出ください。</p>
    <ul class="list_style_non seminar_text_list list-dot-01">
      <li>&#9312;お名前（※会員の方で、分かる方は会員番号もお伝えください）</li>
      <li>&#9313;ご連絡先（お電話番号またはメールアドレス）</li>
      <li>&#9314;参加希望日</li>
      <li>&#9315;お連れするお友達がいらっしゃる方はお友達のお名前</li>
    </ul>
    <p class="text-center mt-5">お電話でも受け付けています。参加ご希望の方はマナビス化粧品会員サポート営業部までフリーダイヤルでお問合せください。</p>
    <div class="d-flex justify-content-center align-items-center mt-5">
        <P>株式会社マナビス化粧品<br>会員サポート営業部</p>
        <img src="@/assets/img/lp/tel.png" alt="電話" class="mx-5">
        <p style="font-size: 3rem;">0120-268-510</p>
    </div>
    
    <h3 class="ttl-cmn-03 mt-5 pt-5" style="font-size: 20px;">【ご参加の皆さまへ】</h3>
    <ul class="seminar_text_list list-dot-01">
      <li>日程に変更があった場合、メール、ホームページ等でお知らせいたします。</li>
      <li>マイクロバス等でご来場の場合、事前にご自身で駐車場の状況を会場側にご確認ください。</li>
    </ul>
    
    <h3 class="ttl-cmn-03 mt-5 pt-5" style="font-size: 20px;">【お願い】</h3>
    <ul class="seminar_text_list list-dot-01">
      <li>コロナ対策の観点より、マスク着用とボールペン、お飲み物をご持参ください。</li>
      <li>入室の際には、検温とアルコール消毒のご協力をお願いいたします。また、発熱等、体調が優れない場合にはご来場をお控えください。</li>
    </ul>

    <p class="text-center mt-5">ご質問やご不明な点などございましたら、会員サポート営業部までお問合せください。</p>
    <div class="d-flex justify-content-center align-items-center mt-5">
        <P>株式会社マナビス化粧品<br>会員サポート営業部</p>
        <img src="@/assets/img/lp/tel.png" alt="電話" class="mx-5">
        <p style="font-size: 3rem;">0120-268-510</p>
    </div>

  </section>
    



  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<!-- 化粧品公式サイトのスタイルを反映 -->
<style src="../../assets/css/custom.css" scoped>
</style>
<style src="../../assets/css/module.css" scoped>
</style>
<style src="../../assets/css/module_sp.css" scoped>
</style>
<style src="../../assets/css/top.css" scoped>
</style>

<style scoped>
.box-top-slide {
  height: initial;
}
.seminar_table thead {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  line-height: 50px;
}
.seminar_table th {
  font-weight: 300;
}
.seminar_table tbody tr {
  border-bottom: 1px solid #eee;
  height: 150px;
}
.seminar_table td {
  vertical-align: middle;
}
.seminar_table td:first-child {
  font-size: 24px;
}
.seminar_table td.w-100px {
  width: 100px;
}
.list_style_non li {
  list-style: none;
  margin-left: 0;
}
button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}

@media screen and (min-width: 1px) and (max-width: 699px) {
  .msc_seminar .d-flex {
    flex-direction: column;
  }
  .only_sp .seminar_table tr {
    height: initial;
  }
  .only_sp .seminar_table th {
    vertical-align: middle;
  }
  .only_sp .seminar_table td {
    padding: 10px 0 10px 20px;
  }
  .only_sp .seminar_table tr:first-child {
     border-top: 1px solid #eee;
  }
  .only_sp .seminar_table tr:first-child td {
    font-size: 24px;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
    window.scroll(0, 0);
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>